import React from "react";
import { Avatar } from "@mui/material";
import {
  Person as PersonIcon,
  Notifications as NotificationsIcon,
} from "@mui/icons-material";
import { getImageDisplayUrl } from "src/network/endpoints";
import NameLogo from "src/@core/components/icons/Name-Logo";

/**
 * Avatar for a notification row: system → Beemz logo; else sender image; else person / bell fallback.
 */
export function renderNotificationAvatar(notification) {
  if (notification.type === "system") {
    return (
      <Avatar sx={{ width: 40, height: 40, bgcolor: "#F3E8FF" }}>
        <NameLogo size={18} />
      </Avatar>
    );
  }

  const senderProfilePic =
    notification.senderId?.image?.profilePic ||
    notification.meta?.senderProfilePic ||
    notification.image ||
    "";

  if (senderProfilePic) {
    return (
      <Avatar
        src={getImageDisplayUrl(senderProfilePic)}
        sx={{ width: 40, height: 40 }}
      />
    );
  }

  return (
    <Avatar sx={{ width: 40, height: 40, bgcolor: "#9C27B0" }}>
      {notification.type ? <PersonIcon /> : <NotificationsIcon />}
    </Avatar>
  );
}
